
import { isNewEntryForApp } from 'Flow2/components/CustomCollections/CustomDataControllers/CustomFormController';
import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    laneIds: [],
    laneTree: [],
    lanes: {},
    activeLane: null,
    order: [],
    error: null,
    loading: false,
    children: {},
    mediaObjects: {
        viewMode: 'list',
        worklist: [],
        workSearch: true
    },
    configObjects: {}
};

const getTvLaneTreeStart = (state, action) => {
    return updateObject(state, { error: null, loading: true });
}

const getTvLaneTreeFail = (state, action) => {
    return updateObject(state, {
        error: action.error,
        loading: false
    });
}

const getElements = (action) => {
    let elements = [];
    if (action.children && action.children.length) {
        elements = action.children.map(item => {
            if (item && item.project && item.project.data && item.project.data.id) {
                return ({ ...item.project, children: item.children || [], id: +item.project.data.id })
            }
        })
    }
    return elements
}

const getSubElements = ({ el }) => {
    let subs = [];
    if (el.children && el.children.length) {
        el.children.forEach(entry => {
            let sub = { data: { ...entry.project.data }, id: +entry.project.data.id, children: entry.children };
            sub.isWerk = true;
            sub.disabled = true;
            subs.push(sub);
        })
    }
    return subs;
}

const getTvLaneTreeSuccess = (state, action) => {
    const laneIds = [];
    const lanes = {};
    const laneTree = [];
    let elements = getElements(action);
    if (elements.length > 0) {
        elements.forEach((item, index) => {
            laneIds.push(item.id);
            laneTree.push(item);
            lanes[item.id] = [];
            lanes.rootId = item.id;
            let children = [];
            if (item.children && item.children.length) {
                item.children.forEach(el => {
                    let subs = getSubElements({ el });
                    if (el.project && el.project.data && el.project.data.id) {
                        let tmp = { ...el.project, id: +el.project.data.id, children: subs };
                        if (el.project.metadata && el.project.metadata.fields
                            && el.project.metadata.fields.txt1 === 'sdk_tvlounge') {
                            tmp.isChild = true;
                        } else {
                            tmp.disabled = true;
                            if (el.project.metadata && el.project.metadata.fields
                                && el.project.metadata.fields.txt1 === 'sdk_werk') tmp.isWerk = true;
                        }
                        children.push(tmp);
                        lanes[item.id].push(el.project.data.id);
                    }
                });
                item.children = children;
            }
        });
        console.log("LOGS: getTvLaneTreeSuccess elements", elements);
    }

    return updateObject(state, {
        laneIds: laneIds,
        laneTree: laneTree,
        loading: false,
        lanes: lanes,
        selectedWorkIds: []
    });
}

const TvTreeReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.TVLANES_GET_PROJECT_TREE_START:
            return getTvLaneTreeStart(state, action);
        case actionTypes.TVLANES_GET_PROJECT_TREE_SUCCESS:
            return getTvLaneTreeSuccess(state, action);
        case actionTypes.TVLANES_GET_PROJECT_TREE_FAIL:
            return getTvLaneTreeFail(state, action);
        case actionTypes.TVLANES_UPDATE_OBJECTS_SUCCESS:
            return { ...state, ...action.payload };
        case actionTypes.TVLANES_UPDATE_MEDIAOBJECTS_SUCCESS:
            return {
                ...state,
                loading: false,
                mediaObjects: { ...state.mediaObjects, ...action.payload }
            }
        default:
            return state;
    }
}

export default TvTreeReducer;
